type RankedRowProps = {
  label: string;
  value: number;
  max: number;
};

export function RankedRow({ label, value, max }: RankedRowProps) {
  const width = Math.max(8, Math.round((value / Math.max(1, max)) * 100));
  return (
    <div className="ranked-row">
      <div className="ranked-row-label">{label}</div>
      <div className="bar-track">
        <div className="bar-fill" style={{ width: `${width}%` }} />
      </div>
      <div className="ranked-row-value">{value}</div>
    </div>
  );
}
